/**
 * Decides whether a button's spinner should reflect the in-flight campaign state
 * transition (#5663). The transition polling is shared per campaign, so without this
 * a Go Live launch lit up the Deploy button too, and both green buttons rendered.
 *
 * `pendingSource` is the source string recorded by useCampaignStateTransition when the
 * transition was dispatched, or null when it was resumed after a page reload (owner
 * unknown). Deploy owns the null case so "Deploying..." survives a mid-deploy reload
 * (#5583); Go Live does not, since its render condition is already false once the
 * campaign is LIVE and published.
 */
export function ownsTransitionSpinner(
  buttonSource: 'go_live_button' | 'deploy_button',
  pendingSource: string | null,
): boolean {
  if (pendingSource === buttonSource) return true;
  return pendingSource === null && buttonSource === 'deploy_button';
}
